import { ProductMain } from "@sourceful/shared-types";

export const checkProductUsesLegacyPrintSides = (product: ProductMain): boolean => {
  return !!product.maxPrintableSides;
};
